var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"not-confirmed"},[_vm._v("Профиль находится на проверке")])
}
var staticRenderFns = []

export { render, staticRenderFns }